
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/founders-thoughts/[slug]",
      function () {
        return require("private-next-pages/founders-thoughts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/founders-thoughts/[slug]"])
      });
    }
  